export default __webpack_public_path__ + "static/media/ae-logo.8eaf3fc3.svg";